import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import { georgeWebHeaderStore } from "components/common/GeorgeWebHeader";
import { PdfViewer } from "components/common/PdfViewer";
import auth from "stores/AuthStore";
import externalInterfaceStore, { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { PocketsLandingPage } from "./PocketsLandingPage";
import { PocketsRoutes } from "./PocketsRoutes";
import { PocketsSigning } from "./PocketsSigning";
import { PocketsStore } from "./PocketsStore";
import { PocketsSuccess } from "./PocketsSuccess";
import { PocketsSummary } from "./PocketsSummary";
import { PocketsFeatureNotAvailableError } from "./PocketsFeatureNotAvailableError";

type IProps = RouteComponentProps & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export default class PocketsContainer extends React.Component<IProps> {
    store: PocketsStore;

    constructor(props: IProps) {
        super(props);
        this.store = new PocketsStore();
    }

    async componentDidMount() {
        pushRoute(PocketsRoutes.ROOT);
        try {
            georgeWebHeaderStore.configure({
                title: ui.__("pockets.document.title"),
            });

            if (auth.authorized) {
                if (!externalInterfaceStore.accountId) {
                    pushRoute("/error");
                } else {
                    await this.store.loadData();

                    if (this.store.hasFeature && this.store.alreadyActivated) {
                        pushRoute(PocketsRoutes.SUCCESS);
                    } else if (!this.store.hasFeature) {
                        pushRoute(PocketsRoutes.ERROR_FEATURE_NOT_AVAILABLE);
                    }
                }

            }
        } catch (error) {
            debug.log("### PocketsContainer.componentDidMount() Failed to load data", error);

            if (!config.DEBUG) {
                pushRoute("/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    render() {
        document.title = ui.__("pockets.document.title");
        return (
            <div>
                <Route exact path={PocketsRoutes.ROOT} component={this.withStore(PocketsLandingPage)} />
                <Route exact path={PocketsRoutes.SUMMARY} component={this.withStore(PocketsSummary)} />
                <Route exact path={PocketsRoutes.SIGNING} component={this.withStore(PocketsSigning)} />
                <Route exact path={PocketsRoutes.SUCCESS} component={this.withStore(PocketsSuccess)} />
                <Route exact path={PocketsRoutes.ERROR_FEATURE_NOT_AVAILABLE} component={PocketsFeatureNotAvailableError} />
                <Route path={PocketsRoutes.PDF} component={() => <PdfViewer {...this.props} uint8Data={this.store.pdfData} />} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pockets/PocketsContainer.tsx